import type { InsightResult, MetricFetchResult } from '../types';

export const metricTileCache = new Map<string, MetricFetchResult>();
export const metricTileInflight = new Map<string, Promise<MetricFetchResult>>();
export const insightTileCache = new Map<string, InsightResult>();

export const clearMetricsFrameworkTileCaches = () => {
  metricTileCache.clear();
  metricTileInflight.clear();
  insightTileCache.clear();
};
